export default Object.freeze({
  Instant: 1,
  Automated: 2,
  Scheduled: 3,
});
